// Pure state derivation for the step-4 "What respondents will hear" card and
// the step-status done badge — one place for the freshness rule so they
// can't drift.

export interface FramingFields {
  aspiration?: string | null;
  respondentFraming?: string | null;
  openerBody?: string | null;
  framingSourceAspiration?: string | null;
}

// True when a framing exists and was written against the current aspiration.
// Vacuously true with no aspiration (nothing to frame).
export function isFramingCurrent(p: FramingFields): boolean {
  const aspiration = p.aspiration?.trim();
  if (!aspiration) return true;
  const present = !!(p.respondentFraming?.trim() || p.openerBody?.trim());
  return present && p.framingSourceAspiration?.trim() === aspiration;
}

export type FramingCardState = 'hidden' | 'generating' | 'ok' | 'stale' | 'missing';

export function deriveFramingState(p: FramingFields & { generating: boolean }): FramingCardState {
  if (!p.aspiration?.trim()) return 'hidden';
  if (p.generating) return 'generating';
  const present = !!(p.respondentFraming?.trim() || p.openerBody?.trim());
  if (!present) return 'missing';
  return isFramingCurrent(p) ? 'ok' : 'stale';
}
